/** dd/mm/aa em TZ Brasil. */
export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", {
      timeZone: "America/Sao_Paulo",
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  } catch {
    return "—";
  }
}

/** "4,2" em vez de "4.2". Vazio retorna "—". */
export function fmtDecimal(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toFixed(1).replace(".", ",");
}

/** "12,3%". 0 ou inválido → "0%". */
export function fmtPct(n) {
  if (!n) return "0%";
  return `${Number(n).toFixed(1).replace(".", ",")}%`;
}

/** Remove tudo que não é dígito e prefixa 55 quando o telefone parece BR sem DDI. */
export function toWhatsAppNumber(raw) {
  const digits = (raw || "").replace(/\D/g, "");
  if (!digits) return "";
  return digits.startsWith("55") ? digits : `55${digits}`;
}
